import { useAppContext } from "@/context/app"
import { Roles } from "@/services/repository/users"
import React, { ReactNode } from "react"
import { useNavigate } from "react-router-dom"


type ErrorFlags = {
    distanceError?: boolean
    generalError?: boolean
    loadingMachineError?: boolean
}

export const ErrorBox = ({
    errors,
    children
}: {
    errors?: ErrorFlags
    children?: ReactNode
}) => {
    const { translates, session } = useAppContext()
    const navigate = useNavigate()
    if (!translates) return null

    const t = (key: string) => translates.for(key)

    const items = [
        { flag: "distanceError", key: "errors.machine_distance_error" },
        { flag: "generalError", key: "errors.general_error" },
        { flag: "loadingMachineError", key: "errors.loading_machine_error" },
    ] as const satisfies ReadonlyArray<{ flag: keyof ErrorFlags; key: string }>

    const activeItems = items.filter(({ flag }) => Boolean(errors?.[flag]))
    if (activeItems.length === 0) return null

    const fallbackChildren = (
        <div>
            {[Roles.SuperAdmin, Roles.HyperAdmin, Roles.CompanyAdmin, Roles.CompanyManager, Roles.Coordinator, Roles.Serviceman].includes(session?.user.role) ? <>
                <a
                    className="btn btn-next main-btn"
                    onClick={() => navigate(`/communal/support`)}
                >
                    {t("page.communal-machine-activate.support")}
                </a>
                <a
                    className="btn btn-next main-btn"
                    onClick={() => navigate(`/communal/support/wizard`)}
                >
                    {t("page.communal-machine-activate.support_form")}
                </a>
            </> : null}
        </div>
    )

    return (
        <div className="error-box-wrap">
            {activeItems.map(({ flag, key }) => (
                <div key={flag} className="critic-error-box">
                    {t(key)}
                </div>
            ))}

            {children ?? fallbackChildren}
        </div>
    )
}